import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';

@Injectable({
    providedIn: 'root'
})
export class PedidoIntegrationErpHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pedido`;
    }

    /** Realiza a integração do pedido com o sistema de terceiros */
    integrate(id: number): Observable<string> {
        return this.customHttp.put<string>(`${this.pathApi}/${id}/integrate`, null);
    }
}
